import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'

export class SortSearchValueObject extends ValueObject {
  #sortBy
  #sortOrder

  constructor({sortBy, sortOrder}) {
    super()
    this.#sortBy = sortBy
    this.#sortOrder = sortOrder
  }

  static create({sortBy, sortOrder}) {
    return new SortSearchValueObject({sortBy, sortOrder})
  }

  static createWithSortMap({config, sort}) {
    const {term, order} = sort
    const orderKey = order.toUpperCase()
    const orderMap = {
      ASC: config.get('ORDER').ASC,
      DESC: config.get('ORDER').DESC
    }

    return new SortSearchValueObject({
      sortBy: term,
      sortOrder: orderMap[orderKey]
    })
  }

  static createForRentingWithSortMapFromUrl({config, sort, url}) {
    const {SEMANTIC_KEYWORDS} = config.get('seo')
    const {FILTER_QUERY_PARAMS, FILTER_NAMES} = config.get('searchFilters')

    const {term, order} = sort
    const orderKey = order.toUpperCase()
    const orderMap = {
      ASC: config.get('ORDER').ASC,
      DESC: config.get('ORDER').DESC
    }

    if (url.includes(SEMANTIC_KEYWORDS.RENTING.NO_ENTRY_FEE)) {
      return new SortSearchValueObject({
        sortBy: FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE,
        sortOrder: orderMap.ASC
      })
    }
    if (url.includes(SEMANTIC_KEYWORDS.RENTING.TARGET_BUYER_PRIVATE)) {
      return new SortSearchValueObject({
        sortBy: FILTER_NAMES.YEAR,
        sortOrder: orderMap.DESC
      })
    }

    const urlQueryParams = new URLSearchParams(url.split('?')[1] || '')
    const sortByQueryParam = FILTER_QUERY_PARAMS[FILTER_NAMES.SORT_BY]
    const sortOrderQueryParamId = FILTER_QUERY_PARAMS[FILTER_NAMES.SORT_ORDER]
    if (urlQueryParams.get(sortByQueryParam) === FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE) {
      const sortOrderId = urlQueryParams.get(sortOrderQueryParamId)
      const sortOrder = sortOrderId === '1' ? orderMap.ASC : orderMap.DESC
      return new SortSearchValueObject({
        sortBy: FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE,
        sortOrder
      })
    }

    return new SortSearchValueObject({
      sortBy: term,
      sortOrder: orderMap[orderKey]
    })
  }

  static createQueryParams({config, sortBy, sortOrder}) {
    const {FILTER_NAMES, FILTER_QUERY_PARAMS, SORT_ORDER_VALUES, SORT_QUERY_PARAMS} = config.get('searchFilters')
    const {RELEVANCE} = config.get('SORT_FIELDS')

    const isDefaultSort = sortBy === RELEVANCE

    return new SortSearchValueObject({
      sortBy: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.SORT_BY],
        value: !isDefaultSort ? SORT_QUERY_PARAMS[sortBy] : null
      }),
      sortOrder: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.SORT_ORDER],
        value: !isDefaultSort ? SORT_ORDER_VALUES[sortOrder] : null
      })
    })
  }

  get sortBy() {
    return this.#sortBy
  }

  get sortOrder() {
    return this.#sortOrder
  }

  get hasQueryParams() {
    return Boolean(Object.keys(this.queryParams).length)
  }

  get queryParams() {
    return {
      ...(!this.#sortBy.isEmpty && {...this.#sortBy.queryParam}),
      ...(!this.#sortOrder.isEmpty && {...this.#sortOrder.queryParam})
    }
  }

  get value() {
    return {sortBy: this.#sortBy, sortOrder: this.#sortOrder}
  }

  toJSON() {
    return {
      sortBy: this.#sortBy,
      sortOrder: this.#sortOrder
    }
  }
}
